/*
 * Mint Mauve: gallery -> variant sync.
 * The theme already moves the gallery when a swatch is picked, but clicking a
 * gallery thumbnail or swiping/arrowing the main photo only changed the image.
 * This selects the matching variant by clicking its swatch, so the theme's own
 * variant logic (labels, price, footbar, add-to-cart id, URL) runs exactly as
 * on a manual swatch click.
 */
(function () {
  if (window.__mmGalleryVariantSync) return;
  window.__mmGalleryVariantSync = true;

  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); });
    }
    return cache[handle];
  }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  // Select the variant whose image is gallery slide `index`.
  function selectForSlide(el, index) {
    var gallery = el.closest('product-gallery');
    var product = el.closest('[data-js-product]');
    if (!gallery || !product || !gallery.options || gallery.options.grouped) return;

    var mediaId = gallery.options.media_id_index[index];
    var handle = product.getAttribute('data-product-handle');
    if (!mediaId || !handle) return;

    getProduct(handle).then(function (p) {
      var matches = p.variants.filter(function (v) { return v.featured_media && v.featured_media.id === mediaId; });
      if (!matches.length) return;
      var sections = product.querySelectorAll('[data-js-product-options] .product-options__section[data-property]');
      p.options.forEach(function (opt, i) {
        var value = matches[0].options[i];
        // Only change options this image decides (e.g. the print); keep the customer's other picks (e.g. size).
        if (!matches.every(function (v) { return v.options[i] === value; })) return;
        // An option that elsewhere shares one photo across its values (e.g. size) is never image-driven,
        // even when some variants are missing their image.
        var sharesPhotos = p.variants.some(function (a) {
          return a.featured_media && p.variants.some(function (b) {
            return b.featured_media && b.featured_media.id === a.featured_media.id && b.options[i] !== a.options[i];
          });
        });
        if (sharesPhotos) return;
        var section = sections[i];
        if (!section) return;
        var target = Array.prototype.find.call(section.querySelectorAll('[data-js-option-value]'), function (el) {
          return norm(el.textContent) === norm(value);
        });
        // Already-active swatches are skipped (the theme marks them active synchronously), so the
        // slide change the theme makes after a swatch pick never re-triggers a selection.
        if (target && !target.classList.contains('active')) target.click();
      });
    });
  }

  // Thumbnail clicks (desktop collage and mobile thumbnail strip).
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-js-product-gallery-thumbnail-item]');
    if (!item) return;
    var siblings = item.parentElement.querySelectorAll(':scope > [data-js-product-gallery-thumbnail-item]');
    selectForSlide(item, Array.prototype.indexOf.call(siblings, item));
  });

  // Main photo swipes and arrows. Slick triggers afterChange through jQuery, so one delegated
  // handler covers every product gallery, including ones initialised later. jQuery ships in the
  // theme's own script, which can finish loading after this file, so wait for it.
  var tries = 0;
  (function bindSlides() {
    if (!window.jQuery) {
      if (++tries < 150) setTimeout(bindSlides, 200);
      return;
    }
    jQuery(document).on('afterChange.mmGallerySync', '[data-js-product-gallery-main-slider]', function (e, slick, current) {
      if (e.target !== this) return;
      var index = parseInt(slick.$slides.eq(current).attr('data-item-index'), 10);
      if (!isNaN(index)) selectForSlide(this, index);
    });
  })();
})();
